import { LostUnitsResponse, LostUnits } from "@deliverr/commons-clients";
import { ApiClient, ApiClientConfig } from "../../common/utils/ApiClient";
import { mustBeDefined } from "../../common/utils/MustBeDefined";

export type InventoryClientConfig = ApiClientConfig;

export class InventoryApiClient {
  private apiClient: ApiClient;

  constructor(
    { baseURL }: InventoryClientConfig = {
      baseURL: mustBeDefined(process.env.REACT_APP_INVENTORY_SERVICE_URL),
    }
  ) {
    this.apiClient = new ApiClient({
      baseURL: `${baseURL}/api/v1/inventory`,
    });
  }

  async getLostUnits(
    selectedPageIndex?: number,
    pageSize?: number
  ): Promise<LostUnitsResponse> {
    try {
      return await this.apiClient.get({
        url: "/stockkeepingunits/lostunits",
        params: {
          selectedPageIndex,
          pageSize,
        },
        authentication: true,
      });
    } catch (ex: any) {
      switch (ex.response.status) {
        case 404:
          return {
            lostUnitsTrackerEntries: [],
            totalPages: 0,
          };
        default:
          throw new Error(ex);
      }
    }
  }

  public async getLostUnit(id: number): Promise<LostUnits> {
    try {
      return await this.apiClient.get({
        url: `/stockkeepingunits/lostunits/${id}`,
        authentication: true,
      });
    } catch (ex: any) {
      switch (ex.response.status) {
        case 404:
          return {};
        default:
          throw new Error(ex);
      }
    }
  }

  async createLostUnits(lostUnits: LostUnits): Promise<LostUnits | undefined> {
    try {
      return await this.apiClient.post({
        url: "/stockkeepingunits/lostunits",
        body: lostUnits,
        authentication: true,
      });
    } catch (ex: any) {
      throw new Error(ex);
    }
  }

  async editLostUnits(lostUnits: LostUnits): Promise<LostUnits | undefined> {
    try {
      return await this.apiClient.put({
        url: "/stockkeepingunits/lostunits",
        body: lostUnits,
        authentication: true,
      });
    } catch (ex: any) {
      throw new Error(ex);
    }
  }

  async deleteLostUnits(id: number): Promise<LostUnitsResponse> {
    try {
      return await this.apiClient.delete({
        url: `/stockkeepingunits/lostunits/archive/${id}`,
        authentication: true,
      });
    } catch (ex: any) {
      throw new Error(ex);
    }
  }

  async filterLostUnits(
    selectedPageIndex?: number,
    pageSize?: number,
    dsku?: string,
    shippingPlanId?: string
  ): Promise<LostUnitsResponse> {
    try {
      return await this.apiClient.post({
        url: "/stockkeepingunits/lostunits/filter",
        body: {
          dsku,
          shippingPlanId,
        },
        params: {
          selectedPageIndex,
          pageSize,
        },
        authentication: true,
      });
    } catch (ex: any) {
      switch (ex.response.status) {
        case 404:
          return {
            lostUnitsTrackerEntries: [],
            totalPages: 0,
          };
        default:
          throw new Error(ex);
      }
    }
  }
}
